import { DOCUMENT_TYPE, documentTypeIconMap } from "Common/dictionaries/documentType";
import locale from "./documentTypeButtonGroupItems.locale";
export default [
    {
        icon: documentTypeIconMap[DOCUMENT_TYPE.GRAPH],
        hint: locale.GRAPH,
        key: DOCUMENT_TYPE.GRAPH,
        text: locale.GRAPH
    },
    {
        icon: documentTypeIconMap[DOCUMENT_TYPE.TABLE],
        hint: locale.TABLE,
        key: DOCUMENT_TYPE.TABLE,
        text: locale.TABLE
    },
    {
        icon: documentTypeIconMap[DOCUMENT_TYPE.MAP],
        hint: locale.MAP,
        key: DOCUMENT_TYPE.MAP,
        text: locale.MAP
    },
    {
        icon: documentTypeIconMap[DOCUMENT_TYPE.CONTENT],
        hint: locale.CONTENT,
        key: DOCUMENT_TYPE.CONTENT,
        text: locale.CONTENT
    }
];
